import { type Checkpoint } from '../../../shared/sync/schemas';
import { pullItems } from '../../sync/items';
import { type ItemDoc } from '../collections/items';
import { type ClewDatabase } from '../database';
import {
  checkpointFallbackId,
  withCheckpointFallback,
} from './checkpointFallback';
import {
  replicateRxCollection,
  type RxReplicationState,
} from 'rxdb/plugins/replication';

export const itemReplicationId = (processId: string) =>
  `items-process-${processId}`;

export const startItemsReplication = (
  db: ClewDatabase,
  userId: string,
  processId: string,
): RxReplicationState<ItemDoc, Checkpoint> => {
  const replicationId = itemReplicationId(processId);

  return replicateRxCollection<ItemDoc, Checkpoint>({
    autoStart: true,
    collection: db.items,
    deletedField: '_deleted',
    live: true,
    pull: {
      batchSize: 100,
      handler: withCheckpointFallback(
        checkpointFallbackId(userId, replicationId),
        async (checkpoint, batchSize) => {
          const result = await pullItems({
            batchSize,
            checkpoint: checkpoint ?? null,
            processId,
          });
          return {
            checkpoint: result.checkpoint ?? undefined,
            documents: result.documents.map((doc) => ({
              ...doc,
              _deleted: Boolean(doc._deleted),
            })),
          };
        },
      ),
    },
    replicationIdentifier: replicationId,
    retryTime: 5_000,
    waitForLeadership: false,
  });
};
